"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.KrakenSDK = void 0;
const sdks_js_1 = require("../lib/sdks.js");
const areas_js_1 = require("./areas.js");
const companies_js_1 = require("./companies.js");
const modelsai_js_1 = require("./modelsai.js");
const outcodes_js_1 = require("./outcodes.js");
const postcodes_js_1 = require("./postcodes.js");
const properties_js_1 = require("./properties.js");
const propertylistings_js_1 = require("./propertylistings.js");
const sectors_js_1 = require("./sectors.js");
const stats_js_1 = require("./stats.js");
const statscrime_js_1 = require("./statscrime.js");
const statslettings_js_1 = require("./statslettings.js");
const statssales_js_1 = require("./statssales.js");
const versioning_js_1 = require("./versioning.js");
class KrakenSDK extends sdks_js_1.ClientSDK {
    get areas() {
        return (this._areas ?? (this._areas = new areas_js_1.Areas(this._options)));
    }
    get companies() {
        return (this._companies ?? (this._companies = new companies_js_1.Companies(this._options)));
    }
    get modelsAI() {
        return (this._modelsAI ?? (this._modelsAI = new modelsai_js_1.ModelsAI(this._options)));
    }
    get outcodes() {
        return (this._outcodes ?? (this._outcodes = new outcodes_js_1.Outcodes(this._options)));
    }
    get postcodes() {
        return (this._postcodes ?? (this._postcodes = new postcodes_js_1.Postcodes(this._options)));
    }
    get properties() {
        return (this._properties ?? (this._properties = new properties_js_1.Properties(this._options)));
    }
    get propertyListings() {
        return (this._propertyListings ?? (this._propertyListings = new propertylistings_js_1.PropertyListings(this._options)));
    }
    get sectors() {
        return (this._sectors ?? (this._sectors = new sectors_js_1.Sectors(this._options)));
    }
    get stats() {
        return (this._stats ?? (this._stats = new stats_js_1.Stats(this._options)));
    }
    get statsCrime() {
        return (this._statsCrime ?? (this._statsCrime = new statscrime_js_1.StatsCrime(this._options)));
    }
    get statsLettings() {
        return (this._statsLettings ?? (this._statsLettings = new statslettings_js_1.StatsLettings(this._options)));
    }
    get statsSales() {
        return (this._statsSales ?? (this._statsSales = new statssales_js_1.StatsSales(this._options)));
    }
    get versioning() {
        return (this._versioning ?? (this._versioning = new versioning_js_1.Versioning(this._options)));
    }
}
exports.KrakenSDK = KrakenSDK;
//# sourceMappingURL=sdk.js.map